import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { Icon } from 'common-components'

export const DropdownListWrapper = styled.div<{ $hasFixedHeight?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  overflow-y: auto;
  ${({ $hasFixedHeight }) =>
    $hasFixedHeight ? `max-height: 320px;` : `flex: 1; min-height: 0;`}
  ${customizeVerticalScrollbarThumbMixin()}
`

export const CrownBadgeIcon = styled(Icon)`
  display: inline-flex;
  margin-top: -1px;
`
